// extracted by mini-css-extract-plugin
module.exports = {"memes":"Memes_memes__23RD1","loading":"Memes_loading__If3AD","container":"Memes_container__1NHlK","memeContainer":"Memes_memeContainer__2GsA_"};